import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73c287f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "swiper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-e" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "swiper-content" }, [
    /*#__PURE__*/_createElementVNode("div", null, "ONE WORLD"),
    /*#__PURE__*/_createElementVNode("div", null, "ONE VILLAGE")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-chat" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "swiper-content" }, [
    /*#__PURE__*/_createElementVNode("p", null, "先锋云信"),
    /*#__PURE__*/_createElementVNode("p", null, "让沟通更高效"),
    /*#__PURE__*/_createElementVNode("div", null, "提供即时通讯、视频会议以及多种具备特色的功能助力组织高效沟通")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-xf" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "swiper-content" }, [
    /*#__PURE__*/_createElementVNode("p", null, "先锋云信"),
    /*#__PURE__*/_createElementVNode("p", null, "安全可靠的协作平台"),
    /*#__PURE__*/_createElementVNode("div", null, "全面支持信创标准，自主知识产权，融合即时通讯、实时协作于一体，专注私有化部署，全平台覆盖，完美支持操作系统，提供即时通讯、视频会议、应用商城等功能和丰富的API接口。")
  ])
], -1))
const _hoisted_6 = { class: "advantage" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "产品优势", -1))
const _hoisted_8 = { class: "ad-detail" }
const _hoisted_9 = { class: "detail" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/traceless.png",
  loading: "lazy"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "复杂消息格式", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, "支持复杂文本格式，市场中独有的特色功能助力提升工作效率！", -1))
const _hoisted_13 = { class: "detail" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/over-group.png",
  loading: "lazy"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "跨组织沟通", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, "先锋云信支持多企业同平台交流，打通企业间交流壁垒。", -1))
const _hoisted_17 = { class: "detail" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/traceless.png",
  loading: "lazy"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "无痕消息", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, "设置无痕消息，涉及项目私密性消息无需担心泄露。", -1))
const _hoisted_21 = { class: "detail" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/AI.jpg",
  loading: "lazy"
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "对接AI大模型", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, "先锋云信对接多种AI大模型，提供强大的搜索引擎助力办公效率。", -1))
const _hoisted_25 = { class: "more-adv" }
const _hoisted_26 = { class: "title-m" }
const _hoisted_27 = {
  key: 0,
  class: "more-detail"
}
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<div class=\"detail-c\" data-v-73c287f0><div class=\"title-sub\" data-v-73c287f0>助力组织高效沟通</div><div class=\"title-o\" data-v-73c287f0><div class=\"title-c\" data-v-73c287f0>支持复杂消息格式</div><div class=\"title-mc\" data-v-73c287f0>轻松地编辑文本和其他文件，传递信息更清晰高效</div></div><div class=\"title-o\" data-v-73c287f0><div class=\"title-c\" data-v-73c287f0>支持跨组织交流</div><div class=\"title-mc\" data-v-73c287f0>支持多企业同平台交流，打通企业间交流壁垒</div></div><div class=\"title-o\" data-v-73c287f0><div class=\"title-c\" data-v-73c287f0>支持点对点文件直传</div><div class=\"title-mc\" data-v-73c287f0>局域网下高效传输超大文件</div></div><div class=\"title-o\" data-v-73c287f0><div class=\"title-c\" data-v-73c287f0>支持复杂类型格式消息</div><div class=\"title-mc\" data-v-73c287f0>轻松地编辑文本和其他文件，传递信息更清晰高效</div></div></div><img src=\"/assets/commu.jpg\" loading=\"lazy\" data-v-73c287f0>", 2)
const _hoisted_30 = [
  _hoisted_28
]
const _hoisted_31 = {
  key: 1,
  class: "more-detail"
}
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"detail-c\" data-v-73c287f0><div class=\"title-sub\" data-v-73c287f0>全方位保障信息安全</div><div class=\"title-o\" data-v-73c287f0><div class=\"title-c\" data-v-73c287f0>数据安全</div><div class=\"title-mc\" data-v-73c287f0>数据经过量子加密，传统方式无法破解</div></div><div class=\"title-o\" data-v-73c287f0><div class=\"title-c\" data-v-73c287f0>私有部署</div><div class=\"title-mc\" data-v-73c287f0>支持私有部署，可以拥有绝对的使用信息安全</div></div><div class=\"title-o\" data-v-73c287f0><div class=\"title-c\" data-v-73c287f0>系统安全</div><div class=\"title-mc\" data-v-73c287f0>采用高可用的系统，实时监控系统运行情况</div></div><div class=\"title-o\" data-v-73c287f0><div class=\"title-c\" data-v-73c287f0>代码加密</div><div class=\"title-mc\" data-v-73c287f0>支持多种加密方式，保证安全可靠</div></div></div><img src=\"/assets/quantum.jpg\" style=\"width:50%;\" loading=\"lazy\" data-v-73c287f0>", 2)
const _hoisted_34 = [
  _hoisted_32
]
const _hoisted_35 = {
  key: 2,
  class: "more-detail"
}
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<div class=\"detail-c\" data-v-73c287f0><div class=\"title-sub\" data-v-73c287f0>产品迭代升级</div><div class=\"title-o\" data-v-73c287f0><div class=\"title-c\" data-v-73c287f0>技术架构升级</div><div class=\"title-mc\" data-v-73c287f0>采用主流架构，集成多种云服务功能</div></div><div class=\"title-o\" data-v-73c287f0><div class=\"title-c\" data-v-73c287f0>用户体验升级</div><div class=\"title-mc\" data-v-73c287f0>强调用户用户体验。包括界面设计的优化、流程的简化等</div></div><div class=\"title-o\" data-v-73c287f0><div class=\"title-c\" data-v-73c287f0>完备技术支持</div><div class=\"title-mc\" data-v-73c287f0>提供完备的产品技术支持，相关问题实时解答</div></div><div class=\"title-o\" data-v-73c287f0><div class=\"title-c\" data-v-73c287f0>产品更新</div><div class=\"title-mc\" data-v-73c287f0>持续迭代产品优化升级，用户及时获取最新功能</div></div></div><img src=\"/assets/commu.jpg\" loading=\"lazy\" data-v-73c287f0>", 2)
const _hoisted_38 = [
  _hoisted_36
]
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<div class=\"os-support\" data-v-73c287f0><div class=\"title\" data-v-73c287f0>适配国产系统助力完善信创生态体系</div><div class=\"desc\" data-v-73c287f0>全面支持银河麒麟、统信UOS、中科方德、深度等国产操作系统，充分助力政府企业单位打造自主可控、安全高效的即时通讯及协同办公平台。</div><div class=\"os-img-container\" data-v-73c287f0><div class=\"os-img\" data-v-73c287f0></div></div></div><div class=\"deploy\" data-v-73c287f0><div class=\"title\" data-v-73c287f0>灵活的部署方式</div><div class=\"deploy-detail\" data-v-73c287f0><div class=\"deploy-card\" data-v-73c287f0><div class=\"deploy-card-t\" data-v-73c287f0>整套通讯系统</div><div class=\"deploy-card-t\" data-v-73c287f0>私有部署</div><div class=\"deploy-card-d\" data-v-73c287f0>通讯系统支持客户自己私有部署</div><div class=\"deploy-card-d\" data-v-73c287f0>可拥有绝对的使用信息安全</div><div class=\"deploy-card-d\" data-v-73c287f0>可拥有高效流畅度的体验</div></div><div class=\"deploy-card\" data-v-73c287f0><div class=\"deploy-card-t\" data-v-73c287f0>应用服务器</div><div class=\"deploy-card-t\" data-v-73c287f0>私有部署</div><div class=\"deploy-card-d\" data-v-73c287f0>通讯系统支持客户自己私有部署</div><div class=\"deploy-card-d\" data-v-73c287f0>可拥有绝对的使用信息安全</div><div class=\"deploy-card-d\" data-v-73c287f0>可拥有高效流畅度的体验</div></div><div class=\"deploy-card\" data-v-73c287f0><div class=\"advise-c\" data-v-73c287f0> 推荐 </div><div class=\"deploy-card-t\" data-v-73c287f0> 先锋云信 </div><div class=\"deploy-card-t\" data-v-73c287f0>使用公有云服务</div><div class=\"deploy-card-d\" data-v-73c287f0>公有云服务可减少企业管理费用</div><div class=\"deploy-card-d\" data-v-73c287f0>同时支持部署使用自己的私有插件</div><div class=\"deploy-card-d\" data-v-73c287f0>可以拥有高效流畅度的体验</div></div></div></div>", 2)

import { defineComponent, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

let clickIndex = ref<number>(1);

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_carousel, { height: "100vh" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_el_carousel_item, null, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _createVNode(_component_el_button, {
            class: "button",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("了解更多")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _hoisted_15,
          _hoisted_16,
          _createVNode(_component_el_button, {
            class: "button",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("了解更多")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _hoisted_19,
          _hoisted_20,
          _createVNode(_component_el_button, {
            class: "button",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("了解更多")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _hoisted_23,
          _hoisted_24,
          _createVNode(_component_el_button, {
            class: "button",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("了解更多")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_el_tabs, {
          modelValue: _unref(clickIndex),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(clickIndex) ? (clickIndex).value = $event : clickIndex = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "助力组织高效沟通",
              name: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "全方位保障信息安全",
              name: 2
            }),
            _createVNode(_component_el_tab_pane, {
              label: "产品迭代升级",
              name: 3
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      (_unref(clickIndex) == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_30))
        : _createCommentVNode("", true),
      (_unref(clickIndex) == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_34))
        : _createCommentVNode("", true),
      (_unref(clickIndex) == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_38))
        : _createCommentVNode("", true)
    ]),
    _hoisted_39
  ]))
}
}

})